export default "__VITE_ASSET__DXZb4fpP__"